import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=33632f53"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33632f53')) {
      api.createRecord('33632f53', component.options)
    } else {
      api.reload('33632f53', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=33632f53", function () {
      api.rerender('33632f53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/emailTemplates/Index.vue"
export default component.exports